import { render, staticRenderFns } from "./FrrDescription.vue?vue&type=template&id=4b74e476&scoped=true&"
import script from "./FrrDescription.vue?vue&type=script&lang=js&"
export * from "./FrrDescription.vue?vue&type=script&lang=js&"
import style0 from "./FrrDescription.sass?vue&type=style&index=0&id=4b74e476&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b74e476",
  null
  
)

export default component.exports